var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-eaec9633-047d-45a3-8026-e6815533793e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-f3ee4b6f-99b6-4e7a-8809-cf6c53ccdf3e {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-f3ee4b6f-99b6-4e7a-8809-cf6c53ccdf3e",
    d: "M21.8,12.21h-1.47v1.6h1.47c.77,0,1.4.63,1.4,1.4v4.32c0,.77-.63,1.4-1.4,1.4h-11.59c-.77,0-1.4-.63-1.4-1.4v-4.32c0-.77.63-1.4,1.4-1.4h5.64v-1.6h-5.64c-1.66,0-3.01,1.35-3.01,3.01v4.32c0,1.66,1.35,3.01,3.01,3.01h11.59c1.66,0,3.01-1.35,3.01-3.01v-4.32c0-1.66-1.35-3.01-3.01-3.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-f3ee4b6f-99b6-4e7a-8809-cf6c53ccdf3e",
    d: "M15.48,15.29l2.64,4.57,2.64-4.57h-1.84v-5.03c0-.44-.36-.8-.8-.8s-.8.36-.8.8v5.03h-1.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/Custom.270f6986781356a15de83fa9934d2d94.svg";
export { ForwardRef as ReactComponent };